
import { motion } from 'framer-motion';
import Navbar from '../../../components/feature/Navbar';
import Footer from '../../../components/feature/Footer';
import { useInView } from '../../../hooks/useInView';
import { Link } from 'react-router-dom';

const HeavyCranesPage = () => {
  const [ref, isInView] = useInView({ threshold: 0.2 });

  const heavyCranes = [
    {
      id: 'sany-scc8500',
      name: 'SANY SCC8500',
      brand: 'SANY',
      capacity: '500 Tons',
      boom: '108m',
      image: 'https://public.readdy.ai/ai/img_res/029fa6327865caa3f930ed81d7a3adee.jpg',
      features: ['Maximum Capacity', 'Extended Boom', 'Heavy Infrastructure'],
      specs: {
        maxCapacity: '500 tons',
        boomLength: '108m',
        type: 'Crawler Crane',
        year: '2022'
      }
    },
    {
      id: 'xcmg-xct300',
      name: 'XCMG XCT300',
      brand: 'XCMG',
      capacity: '300 Tons',
      boom: '88m',
      image: 'https://readdy.ai/api/search-image?query=powerful%20XCMG%20XCT300%20all%20terrain%20crane%20300%20ton%20capacity%20on%20construction%20site%20professional%20industrial%20photography%20modern%20mobile%20crane%20with%20telescopic%20boom%20multiple%20axles%20visible%20working%20on%20large%20project%20sandy%20terrain%20Saudi%20Arabia%20bright%20daylight%20three%20quarter%20angle%20showing%20crane%20versatility%20and%20strength&width=900&height=700&seq=xcmg-xct300-heavy-002&orientation=landscape',
      features: ['All Terrain', 'Fast Deployment', 'Urban Projects'],
      specs: {
        maxCapacity: '300 tons',
        boomLength: '88m',
        type: 'All Terrain Crane',
        year: '2023'
      }
    },
    {
      id: 'tadano-gr1000xl',
      name: 'Tadano GR-1000XL',
      capacity: '100 Tons',
      brand: 'Tadano',
      boom: '60m',
      image: 'https://readdy.ai/api/search-image?query=Tadano%20GR1000XL%20rough%20terrain%20crane%20100%20ton%20capacity%20on%20construction%20site%20professional%20industrial%20photography%20reliable%20mobile%20crane%20with%20telescopic%20boom%20working%20on%20infrastructure%20project%20sandy%20terrain%20Saudi%20Arabia%20bright%20daylight%20side%20angle%20showing%20crane%20stability%20and%20precision&width=900&height=700&seq=tadano-gr1000xl-heavy-003&orientation=landscape',
      features: ['Rough Terrain', 'High Stability', 'Versatile Use'],
      specs: {
        maxCapacity: '100 tons',
        boomLength: '60m',
        type: 'Rough Terrain Crane',
        year: '2023'
      }
    },
    {
      id: 'sany-sac2500',
      name: 'SANY SAC2500',
      brand: 'SANY',
      capacity: '250 Tons',
      boom: '80m',
      image: 'https://readdy.ai/api/search-image?query=SANY%20SAC2500%20all%20terrain%20crane%20250%20ton%20capacity%20on%20major%20construction%20site%20professional%20industrial%20photography%20heavy%20duty%20mobile%20crane%20with%20extended%20boom%20multiple%20axles%20working%20on%20large%20infrastructure%20project%20sandy%20terrain%20Saudi%20Arabia%20bright%20daylight%20front%20three%20quarter%20angle%20showing%20crane%20power%20and%20mobility&width=900&height=700&seq=sany-sac2500-heavy-004&orientation=landscape',
      features: ['All Terrain', 'Long Reach', 'Heavy Lifting'],
      specs: {
        maxCapacity: '250 tons',
        boomLength: '80m',
        type: 'All Terrain Crane',
        year: '2022'
      }
    },
    {
      id: 'xcmg-qay200',
      name: 'XCMG QAY200',
      brand: 'XCMG',
      capacity: '200 Tons',
      boom: '73m',
      image: 'https://readdy.ai/api/search-image?query=XCMG%20QAY200%20all%20terrain%20crane%20200%20ton%20capacity%20on%20construction%20site%20professional%20industrial%20photography%20modern%20mobile%20crane%20with%20telescopic%20boom%20working%20on%20commercial%20building%20project%20sandy%20terrain%20Saudi%20Arabia%20bright%20daylight%20side%20angle%20showing%20crane%20efficiency%20and%20reach&width=900&height=700&seq=xcmg-qay200-heavy-005&orientation=landscape',
      features: ['All Terrain', 'Quick Setup', 'Commercial Projects'],
      specs: {
        maxCapacity: '200 tons',
        boomLength: '73m',
        type: 'All Terrain Crane',
        year: '2023'
      }
    },
    {
      id: 'tadano-atf130',
      name: 'Tadano ATF 130G-5',
      brand: 'Tadano',
      capacity: '130 Tons',
      boom: '60m',
      image: 'https://readdy.ai/api/search-image?query=Tadano%20ATF130G5%20all%20terrain%20crane%20130%20ton%20capacity%20on%20construction%20site%20professional%20industrial%20photography%20reliable%20mobile%20crane%20with%20telescopic%20boom%20working%20on%20infrastructure%20project%20sandy%20terrain%20Saudi%20Arabia%20bright%20daylight%20three%20quarter%20angle%20showing%20crane%20versatility%20and%20precision&width=900&height=700&seq=tadano-atf130-heavy-006&orientation=landscape',
      features: ['All Terrain', 'Compact Design', 'Urban Access'],
      specs: {
        maxCapacity: '130 tons',
        boomLength: '60m',
        type: 'All Terrain Crane',
        year: '2022'
      }
    },
    {
      id: 'sany-scc4000',
      name: 'SANY SCC4000',
      brand: 'SANY',
      capacity: '400 Tons',
      boom: '96m',
      image: 'https://readdy.ai/api/search-image?query=massive%20SANY%20SCC4000%20crawler%20crane%20400%20ton%20capacity%20on%20major%20construction%20site%20professional%20industrial%20photography%20heavy%20duty%20lifting%20equipment%20with%20lattice%20boom%20operator%20cabin%20visible%20sandy%20terrain%20Saudi%20Arabia%20bright%20daylight%20side%20angle%20showing%20full%20crane%20structure%20and%20massive%20power&width=900&height=700&seq=sany-scc4000-heavy-007&orientation=landscape',
      features: ['Crawler Type', 'Maximum Stability', 'Heavy Projects'],
      specs: {
        maxCapacity: '400 tons',
        boomLength: '96m',
        type: 'Crawler Crane',
        year: '2023'
      }
    },
    {
      id: 'xcmg-xct100',
      name: 'XCMG XCT100',
      brand: 'XCMG',
      capacity: '100 Tons',
      boom: '60.5m',
      image: 'https://readdy.ai/api/search-image?query=XCMG%20XCT100%20truck%20crane%20100%20ton%20capacity%20on%20construction%20site%20professional%20industrial%20photography%20modern%20mobile%20crane%20with%20telescopic%20boom%20working%20on%20commercial%20project%20sandy%20terrain%20Saudi%20Arabia%20bright%20daylight%20side%20angle%20showing%20crane%20efficiency%20and%20mobility&width=900&height=700&seq=xcmg-xct100-heavy-008&orientation=landscape',
      features: ['Truck Mounted', 'Fast Travel', 'Efficient Operation'],
      specs: {
        maxCapacity: '100 tons',
        boomLength: '60.5m',
        type: 'Truck Crane',
        year: '2023'
      }
    },
    {
      id: 'sany-stc750',
      name: 'SANY STC750',
      brand: 'SANY',
      capacity: '75 Tons',
      boom: '56m',
      image: 'https://readdy.ai/api/search-image?query=SANY%20STC750%20truck%20crane%2075%20ton%20capacity%20on%20construction%20site%20professional%20industrial%20photography%20reliable%20mobile%20crane%20with%20telescopic%20boom%20working%20on%20building%20project%20sandy%20terrain%20Saudi%20Arabia%20bright%20daylight%20three%20quarter%20angle%20showing%20crane%20versatility%20and%20reach&width=900&height=700&seq=sany-stc750-heavy-009&orientation=landscape',
      features: ['Truck Mounted', 'Versatile', 'Medium Projects'],
      specs: {
        maxCapacity: '75 tons',
        boomLength: '56m',
        type: 'Truck Crane',
        year: '2022'
      }
    },
    {
      id: 'tadano-gr800xl',
      name: 'Tadano GR-800XL',
      brand: 'Tadano',
      capacity: '80 Tons',
      boom: '51m',
      image: 'https://readdy.ai/api/search-image?query=Tadano%20GR800XL%20rough%20terrain%20crane%2080%20ton%20capacity%20on%20construction%20site%20professional%20industrial%20photography%20reliable%20mobile%20crane%20with%20telescopic%20boom%20working%20on%20infrastructure%20project%20sandy%20terrain%20Saudi%20Arabia%20bright%20daylight%20side%20angle%20showing%20crane%20stability%20and%20power&width=900&height=700&seq=tadano-gr800xl-heavy-010&orientation=landscape',
      features: ['Rough Terrain', 'High Mobility', 'Reliable Performance'],
      specs: {
        maxCapacity: '80 tons',
        boomLength: '51m',
        type: 'Rough Terrain Crane',
        year: '2023'
      }
    },
    {
      id: 'xcmg-qay160',
      name: 'XCMG QAY160',
      brand: 'XCMG',
      capacity: '160 Tons',
      boom: '68m',
      image: 'https://readdy.ai/api/search-image?query=XCMG%20QAY160%20all%20terrain%20crane%20160%20ton%20capacity%20on%20construction%20site%20professional%20industrial%20photography%20modern%20mobile%20crane%20with%20telescopic%20boom%20working%20on%20large%20building%20project%20sandy%20terrain%20Saudi%20Arabia%20bright%20daylight%20three%20quarter%20angle%20showing%20crane%20power%20and%20efficiency&width=900&height=700&seq=xcmg-qay160-heavy-011&orientation=landscape',
      features: ['All Terrain', 'Long Reach', 'Heavy Duty'],
      specs: {
        maxCapacity: '160 tons',
        boomLength: '68m',
        type: 'All Terrain Crane',
        year: '2022'
      }
    },
    {
      id: 'sany-scc2500',
      name: 'SANY SCC2500',
      brand: 'SANY',
      capacity: '250 Tons',
      boom: '84m',
      image: 'https://readdy.ai/api/search-image?query=SANY%20SCC2500%20crawler%20crane%20250%20ton%20capacity%20on%20major%20construction%20site%20professional%20industrial%20photography%20heavy%20duty%20lifting%20equipment%20with%20lattice%20boom%20operator%20cabin%20visible%20sandy%20terrain%20Saudi%20Arabia%20bright%20daylight%20side%20angle%20showing%20full%20crane%20structure%20and%20power&width=900&height=700&seq=sany-scc2500-heavy-012&orientation=landscape',
      features: ['Crawler Type', 'Heavy Lifting', 'Major Projects'],
      specs: {
        maxCapacity: '250 tons',
        boomLength: '84m',
        type: 'Crawler Crane',
        year: '2023'
      }
    }
  ];

  return (
    <div className="min-h-screen bg-white font-inter">
      <Navbar />
      
      <main className="pt-32">
        {/* Hero Section */}
        <section className="relative py-32 overflow-hidden">
          <div className="absolute inset-0 z-0">
            <img
              src="https://readdy.ai/api/search-image?query=massive%20heavy%20duty%20crane%20fleet%20on%20large%20construction%20site%20professional%20industrial%20photography%20multiple%20large%20cranes%20working%20together%20on%20major%20infrastructure%20project%20sandy%20terrain%20Saudi%20Arabia%20bright%20daylight%20aerial%20view%20showing%20scale%20and%20power%20of%20heavy%20equipment&width=1920&height=800&seq=heavy-cranes-hero-main&orientation=landscape"
              alt="Heavy Cranes"
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-b from-primary/80 via-primary/70 to-primary/80"></div>
          </div>

          <div className="container mx-auto px-4 lg:px-8 relative z-10">
            <motion.div
              initial={{ opacity: 0, y: 50 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8 }}
              className="text-center max-w-4xl mx-auto"
            >
              <motion.div
                initial={{ opacity: 0, scale: 0.8 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.8, delay: 0.2 }}
                className="flex items-center justify-center gap-4 mb-6"
              >
                <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/8/8e/Sany_logo.svg/320px-Sany_logo.svg.png" alt="SANY" className="h-12 brightness-0 invert" />
                <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/f/f5/XCMG_logo.svg/320px-XCMG_logo.svg.png" alt="XCMG" className="h-12 brightness-0 invert" />
                <img src="https://www.tadano.com/shared/images/common/logo.svg" alt="Tadano" className="h-12 brightness-0 invert" />
              </motion.div>
              <motion.h1 
                className="text-5xl md:text-7xl font-poppins font-black text-white mb-6"
                initial={{ opacity: 0, scale: 0.8 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.8, delay: 0.3 }}
              >
                HEAVY DUTY CRANES
              </motion.h1>
              <motion.p 
                className="text-xl md:text-2xl text-white/90 font-inter leading-relaxed mb-8"
                initial={{ opacity: 0, y: 30 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8, delay: 0.4 }}
              >
                Premium fleet of heavy-duty cranes from 25 to 500 tons capacity
              </motion.p>
              <motion.div
                initial={{ opacity: 0, y: 30 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8, delay: 0.5 }}
                className="flex flex-wrap items-center justify-center gap-8 text-white"
              >
                <div className="flex items-center gap-3">
                  <div className="w-12 h-12 bg-accent rounded-lg flex items-center justify-center">
                    <i className="ri-weight-line text-2xl"></i>
                  </div>
                  <div className="text-left">
                    <div className="font-poppins font-bold text-2xl">25-500</div>
                    <div className="text-white/80 text-sm">Ton Capacity</div>
                  </div>
                </div>
                <div className="flex items-center gap-3">
                  <div className="w-12 h-12 bg-accent rounded-lg flex items-center justify-center">
                    <i className="ri-truck-line text-2xl"></i>
                  </div>
                  <div className="text-left">
                    <div className="font-poppins font-bold text-2xl">12+</div>
                    <div className="text-white/80 text-sm">Heavy Cranes</div>
                  </div>
                </div>
                <div className="flex items-center gap-3">
                  <div className="w-12 h-12 bg-accent rounded-lg flex items-center justify-center">
                    <i className="ri-shield-check-line text-2xl"></i>
                  </div>
                  <div className="text-left">
                    <div className="font-poppins font-bold text-2xl">100%</div>
                    <div className="text-white/80 text-sm">Safety Certified</div>
                  </div>
                </div>
              </motion.div>
            </motion.div>
          </div>
        </section>

        {/* Cranes Grid */}
        <section className="py-24 bg-white" ref={ref}>
          <div className="container mx-auto px-4 lg:px-8">
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              animate={isInView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.6 }}
              className="text-center mb-16"
            >
              <div className="flex items-center justify-center gap-2 mb-4">
                <div className="w-2 h-2 bg-accent rounded-full"></div>
                <span className="text-accent font-inter font-semibold text-sm uppercase tracking-wider">Our Fleet</span>
              </div>
              <h2 className="text-5xl md:text-6xl font-poppins font-black text-primary mb-6">
                Available Heavy Cranes
              </h2>
              <p className="text-neutral-500 font-inter text-xl max-w-2xl mx-auto">
                Top-tier equipment from industry leaders for demanding projects
              </p>
            </motion.div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {heavyCranes.map((crane, index) => (
                <motion.div
                  key={crane.id}
                  initial={{ opacity: 0, y: 50 }}
                  animate={isInView ? { opacity: 1, y: 0 } : {}}
                  transition={{ duration: 0.6, delay: index * 0.1 }}
                  whileHover={{ y: -10 }}
                  className="bg-white rounded-3xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 group"
                >
                  <Link to={`/cranes/heavy/${crane.id}`} className="block">
                    <div className="relative h-72 w-full overflow-hidden">
                      <img
                        src={crane.image}
                        alt={crane.name}
                        className="w-full h-full object-cover object-center group-hover:scale-110 transition-transform duration-500"
                      />
                      <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent"></div>
                      <div className="absolute top-4 right-4">
                        <div className="px-4 py-2 bg-accent rounded-full">
                          <span className="text-white font-inter font-bold text-sm">{crane.capacity}</span>
                        </div>
                      </div>
                      <div className="absolute bottom-4 left-4 right-4">
                        <div className="flex items-center gap-2 mb-2">
                          <img 
                            src={crane.brand === 'SANY' ? 'https://upload.wikimedia.org/wikipedia/commons/thumb/8/8e/Sany_logo.svg/320px-Sany_logo.svg.png' : crane.brand === 'XCMG' ? 'https://upload.wikimedia.org/wikipedia/commons/thumb/f/f5/XCMG_logo.svg/320px-XCMG_logo.svg.png' : 'https://www.tadano.com/shared/images/common/logo.svg'} 
                            alt={crane.brand} 
                            className="h-6 brightness-0 invert" 
                          />
                        </div>
                        <h3 className="text-2xl font-poppins font-black text-white">
                          {crane.name}
                        </h3>
                      </div>
                    </div>
                    
                    <div className="p-6">
                      <div className="flex items-center gap-4 mb-4">
                        <div className="flex items-center gap-2 text-neutral-600">
                          <i className="ri-ruler-line text-accent"></i>
                          <span className="font-inter text-sm">Boom: {crane.boom}</span>
                        </div>
                        <div className="flex items-center gap-2 text-neutral-600">
                          <i className="ri-calendar-line text-accent"></i>
                          <span className="font-inter text-sm">{crane.specs.year}</span>
                        </div>
                      </div>

                      <div className="flex flex-wrap gap-2 mb-4">
                        {crane.features.map((feature, idx) => (
                          <span
                            key={idx}
                            className="px-3 py-1 bg-neutral-100 text-neutral-700 rounded-full font-inter text-xs"
                          >
                            {feature}
                          </span>
                        ))}
                      </div>

                      <div className="flex items-center justify-between pt-4 border-t border-neutral-100">
                        <span className="text-neutral-500 font-inter text-sm">{crane.specs.type}</span>
                        <div className="flex items-center gap-2 text-accent font-inter font-bold text-sm group-hover:gap-3 transition-all duration-300">
                          View Details
                          <div className="w-5 h-5 flex items-center justify-center">
                            <i className="ri-arrow-right-line"></i>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Link>
                </motion.div>
              ))}
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="py-24 bg-neutral-50">
          <div className="container mx-auto px-4 lg:px-8">
            <motion.div
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8 }}
              className="relative bg-gradient-to-br from-primary to-accent rounded-3xl p-12 md:p-16 overflow-hidden"
            >
              <div className="absolute inset-0 opacity-10">
                <div className="absolute top-0 right-0 w-96 h-96 bg-white rounded-full blur-3xl"></div>
                <div className="absolute bottom-0 left-0 w-96 h-96 bg-white rounded-full blur-3xl"></div>
              </div>

              <div className="relative z-10 text-center max-w-3xl mx-auto">
                <h2 className="text-4xl md:text-5xl font-poppins font-black text-white mb-6">
                  Need a Heavy Crane?
                </h2>
                <p className="text-xl text-white/90 font-inter mb-8">
                  Contact us for availability and pricing
                </p>
                <div className="flex flex-col sm:flex-row gap-4 justify-center">
                  <motion.a
                    href="/#contact"
                    onClick={(e) => {
                      e.preventDefault();
                      window.REACT_APP_NAVIGATE('/');
                      setTimeout(() => {
                        const element = document.querySelector('#contact');
                        if (element) {
                          element.scrollIntoView({ behavior: 'smooth' });
                        }
                      }, 100);
                    }}
                    whileHover={{ scale: 1.05 }}
                    whileTap={{ scale: 0.95 }}
                    className="px-8 py-4 bg-white text-primary rounded-full font-poppins font-bold text-lg hover:shadow-xl transition-all duration-300 cursor-pointer whitespace-nowrap"
                  >
                    Get a Quote
                  </motion.a>
                  <motion.a
                    href="tel:+966123456789"
                    whileHover={{ scale: 1.05 }}
                    whileTap={{ scale: 0.95 }}
                    className="px-8 py-4 bg-white/20 text-white rounded-full font-poppins font-bold text-lg hover:bg-white/30 backdrop-blur-sm transition-all duration-300 cursor-pointer whitespace-nowrap"
                  >
                    Call Us Now
                  </motion.a>
                </div>
              </div>
            </motion.div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default HeavyCranesPage;
